import { Controllers, ProblemResult, PagedResult } from "@infoland/iprova-api";

interface TeamBase {
    name: string;
    description: string;
    team_id: string;
    memberships: Membership[];
    managers: Manager[];
}

//API type (internal)
interface ApiTeam extends TeamBase {
    last_visited: string;
}

// public type
export interface Team extends TeamBase {
    last_visited?: Date;
}

export interface Membership {
    user_id: string;
    user_group_id: string;
    name: string;
}

export interface Member {
    user_id: string;
    name: string;
}

export interface Manager {
    user_id: string;
    name: string;
}

export interface TeamFilter {
    name?: string;
    team_ids?: string[];
}

export class TeamPagedResult {
    items: Team[];
    totalItems: number;
    constructor(items: Team[], totalItems: number) {
        this.items = items;
        this.totalItems = totalItems;
    }
}

export async function GetTeams(filter: TeamFilter, limit: number, offset: number): Promise<TeamPagedResult> {
    let response = null;
    if (!filter.name && !filter.team_ids) {
        const getResponse = await Controllers.GenericController.getPagedResultAsync<ApiTeam>(
            `teams?include_memberships=true&limit=${limit}&offset=${offset}`
        );
        response = new TeamPagedResult(apiTeamsToTeams(getResponse.items), getResponse.totalItems);
    } else {
        const result = await Controllers.GenericController.postAsync<TeamFilter, string | ProblemResult<string>>("teams/filter", filter);
        const created_identifier: string = (result as any)?.created_identifier;
        if (created_identifier) {
            const getResponse = await Controllers.GenericController.getPagedResultAsync<ApiTeam>(
                `/teams/filter/${created_identifier}?include_memberships=true&limit=${limit}&offset=${offset}`
            );
            response = new TeamPagedResult(apiTeamsToTeams(getResponse.items), getResponse.totalItems);
        }
    }
    return response;
}

export async function GetMyTeams(): Promise<Team[]> {
    const teamsData = await Controllers.GenericController.getAsync<ApiTeam[]>("users/me/teams?include_memberships=true");
    return apiTeamsToTeams(teamsData);
}

function apiTeamsToTeams(teamsData: ApiTeam[]): Team[] {
    const teams = [];

    for (let i = 0; i < teamsData.length; i++) {
        let teamApiLastVisited: Date;

        if (teamsData[i].last_visited) teamApiLastVisited = teamsData[i].last_visited.toDate();

        const team: Team = {
            name: teamsData[i].name,
            description: teamsData[i].description,
            team_id: teamsData[i].team_id,
            memberships: teamsData[i].memberships,
            managers: teamsData[i].managers,
            last_visited: teamApiLastVisited
        };

        teams.push(team);
    }

    return teams;
}
